export default __webpack_public_path__ + "static/media/style17.0b99835b.svg";